import { atom } from "recoil";

export enum CampaignScreen {
    TAG,
    EMAIL,
    WEBHOOK,
    PUSH_NOTIFICATION,
    SMS_NOTIFICATION,
  };

  export const CampaingBuilderFormAtom = atom<CampaignScreen | null>({
    key: "CampaingBuilderFormAtom",
    default: null,
  });
  